import React from 'react';

import {
  FormControl,
  FormLabel,
  HStack,
  Radio,
  RadioGroup,
} from '../../core-ui';
import { defineGetters } from '../../support/defineGetters';
import { AccessLevel } from '../../types/shared/User';

const accessLevelToLabel = defineGetters<AccessLevel>({
  NONE: () => t('No access'),
  READ: () => t('Read-only'),
  WRITE: () => t('Full'),
});

type Props = {
  label: string;
  onChange: (value: AccessLevel) => void;
  value: AccessLevel;
};

export default function UserPermissionSelect(props: Props) {
  const { label, onChange, value } = props;
  const options = Object.keys(accessLevelToLabel);
  return (
    <FormControl as="fieldset">
      <FormLabel as="legend">{label}</FormLabel>

      <RadioGroup
        onChange={(value) => {
          onChange(value as AccessLevel);
        }}
        value={value}
      >
        <HStack spacing={5}>
          {options.map((key) => (
            <Radio key={key} value={key}>
              {accessLevelToLabel[key]}
            </Radio>
          ))}
        </HStack>
      </RadioGroup>
    </FormControl>
  );
}
